<template>
  <div :class="classes">
    <div class="row">
      <div class="col-8">
        <span class="dx-card-header__icon-box" @click="toggleVisibility">
          <span class="dx-card-header__icon-box__icon dx-card-header__icon-box__icon--eye">
            <icon name="eye" />
          </span>
          <span class="dx-card-header__icon-box__icon dx-card-header__icon-box__icon--eye-slash">
            <icon name="eye-slash" />
          </span>
        </span>
        <span class="dx-card-header__item-type">
          <small>{{ $t(itemType) }}</small>
          <strong>
            {{ answerValue }}
          </strong>
        </span>
      </div>
      <div class="col-4 text-right">
        <div class="dx-card-header__id">
          {{ idValue }}
        </div>
        <div class="dx-card-header__level">
          <strong>
            {{ levelValue }}
          </strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-awesome/icons/eye'
import 'vue-awesome/icons/eye-slash'

export default {
  name: 'dx-card-header',
  props: {
    id: Number,
    answer: String,
    itemType: String,
    level: String
  },
  data () {
    return {
      visible: true
    }
  },
  computed: {
    answerValue () {
      if (this.visible) {
        return this.answer
      }
      return '***'
    },
    idValue () {
      if (this.visible) {
        return `#${this.id}`
      }
      return '#***'
    },
    levelValue () {
      if (this.visible) {
        return this.$t(this.level)
      }
      return '***'
    },
    classes () {
      return {
        'dx-card-header': true,
        'dx-card-header--invisible': !this.visible
      }
    }
  },
  methods: {
    toggleVisibility () {
      this.visible = !this.visible
      this.$emit('toggle-visibility', this.visible)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DxCardHeader.vue